export type ActionProps =
  { type: "selectValue"; value: string; name: string } | { type: "unSelectValue"; value: string };

export type selectedItemProps = Record<string, { name: string }>;

export const initialState: selectedItemProps = {};

export const formStateReducer = (
  state: selectedItemProps,
  action: ActionProps,
): selectedItemProps => {
  switch (action.type) {
    case "selectValue":
      return {
        ...state,
        [action.value]: { name: action.name },
      };
    case "unSelectValue": {
      const prevObject = state;
      delete prevObject[action.value];
      return { ...prevObject };
    }
    default:
      return state;
  }
};
